import { View } from 'react-native'
import { styled } from '~/utils'

export const Wrapper = styled(View, () => {
  return {
    base: {},
  }
})
